import { useCallback } from 'react';
import { useBridgeHiddenFields } from '../../hooks';

export const useBridgeEntity = () => {
  const { data: bridgeHiddenFields } = useBridgeHiddenFields();

  const isBridgeEntity = useCallback((entityName: string) => entityName in bridgeHiddenFields, [bridgeHiddenFields]);

  return { bridgeHiddenFields, isBridgeEntity };
};
